import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/logo11.png';
import { FaLinkedin, FaFacebookF } from 'react-icons/fa';
import { AiOutlineTwitter, AiFillInstagram } from 'react-icons/ai';
import './Footer.css'; // Import the CSS file

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer>
            <div className="footer__container">
                <article>
                    <Link to="/" className='logo'>
                        <img src={Logo} alt="Footer Logo" />
                    </Link>
                    <p>
                    At First Take Interviews, we're your premier destination for a comprehensive library of video references.
                    </p>
                    <div className="footer__socials">
                        <a href="https://linkedin.com/" target="_blank" rel='noreferrer noopener'><FaLinkedin/></a>
                        <a href="https://facebook.com/" target="_blank" rel='noreferrer noopener'><FaFacebookF/></a>
                        <a href="https://twitter.com/" target="_blank" rel='noreferrer noopener'><AiOutlineTwitter/></a>
                        <a href="https://instagram.com/" target="_blank" rel='noreferrer noopener'><AiFillInstagram/></a>
                    </div>
                </article>
                <article>
                    <h4>Permalinks</h4>
                    <Link to="/About">About</Link>
                    <Link to="/Service">Service</Link>
                    <Link to="/Contact">Contact</Link>
                    <Link to="/Login">Sign in</Link>
                    <Link to="/makerequest">Candidate Request </Link>
                </article>
                <article>
                    <h4>Insights</h4>
                    
                    <Link to="/">FAQs</Link>
                </article> 
                <article>
                    <h4>Get In Touch</h4>
                    <Link to="/Contact">Contact </Link>
                    
                </article>
            </div>   
            <div className="footer__copyright">
            <small> {currentYear} FIRST TAKE INTERVIEWS INC &copy; All Rights Reserved</small>
            </div>
        </footer>
    );
};

export default Footer;
